import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';

/**
 * Servicio para obtener la dirección IP pública del cliente utilizando la API de ipify.
 *
 * Este servicio proporciona una forma sencilla de obtener la IP pública del cliente
 * haciendo una solicitud a la API de ipify, que devuelve la IP del cliente.
 *
 * El servicio se proporciona a nivel global en la aplicación como un singleton,
 * lo que significa que habrá solo una instancia de este servicio en toda la app.
 */
@Injectable({
  providedIn: 'root',
})
export class IpService {
  /**
   * URL base de la API de ipify.
   */
  private url: string = 'https://api.ipify.org';

  /**
   * Crea una instancia de IpService.
   *
   * @param http - El cliente HTTP para realizar la solicitud a la API.
   */
  constructor(private http: HttpClient) {}

  /**
   * Obtiene la dirección IP pública del cliente.
   * Realiza una solicitud GET a la API de ipify con el parámetro de formato `json`.
   *
   * @returns Una promesa que resuelve con la respuesta de la API, que contiene la dirección IP.
   */
  get(): Promise<any> {
    const params = new HttpParams().set('format', 'json');
    return firstValueFrom(this.http.get(this.url, { params }));
  }
}
